import React, {useState, useEffect} from 'react';
import {View, StyleSheet, Animated, Platform} from 'react-native';

const Threedot = () => {
   const [dotOne] = useState(new Animated.Value(0));
   const [dotTwo] = useState(new Animated.Value(0));
   const [dotThree] = useState(new Animated.Value(0));

   const runAnimation = () => {
      Animated.sequence([
         Animated.timing(dotOne, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotTwo, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotThree, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotOne, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotTwo, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotThree, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
      ]).start(() => {
         runAnimation();
      });
   };

   useEffect(() => {
      runAnimation();
   }, []);

   const scaleDotOne = dotOne.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });

   const scaleDotTwo = dotTwo.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });

   const scaleDotThree = dotThree.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });
   const bgClrDotOne = dotOne.interpolate({
      inputRange: [0, 1],
      outputRange: ['#ffffff', '#003DA6'],
   });

   const bgClrDotTwo = dotTwo.interpolate({
      inputRange: [0, 1],
      outputRange: ['#ffffff', '#003DA6'],
   });

   const bgClrDotThree = dotThree.interpolate({
      inputRange: [0, 1],
      outputRange: ['#ffffff', '#003DA6'],
   });
   const isWeb = Platform.OS === 'web';
   return (
      <View
         style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            flex: Platform.OS !== 'web' ? 1 : null,
         }}>
         <View style={styles.container}>
            <Animated.View
               style={[
                  styles.dot,
                  {
                     transform: isWeb ? null : [{scale: scaleDotOne}],
                     backgroundColor: !isWeb ? 'white' : bgClrDotOne,
                  },
               ]}
            />
            <Animated.View
               style={[
                  styles.dot,
                  {
                     transform: isWeb ? null : [{scale: scaleDotTwo}],
                     backgroundColor: !isWeb ? 'white' : bgClrDotTwo,
                  },
               ]}
            />
            <Animated.View
               style={[
                  styles.dot,
                  {
                     transform: isWeb ? null : [{scale: scaleDotThree}],
                     backgroundColor: !isWeb ? 'white' : bgClrDotThree,
                  },
               ]}
            />
         </View>
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
   },
   dot: {
      width: 16,
      height: 16,
      borderRadius: 8,
      backgroundColor: 'white',
      marginHorizontal: 5,
   },
});
export default Threedot;
